module.exports = __webpack_public_path__ + "static/removals-5be15153e46341e7a7c124823052c0ba.jpg";